
// Highly distinct color palette for maximum visibility - no similar colors
const DISTINCT_COLORS = [
  "#e11d48", // rose-600 - bright pink/red
  "#2563eb", // blue-600 - true blue
  "#16a34a", // green-600 - green
  "#f59e0b", // amber-500 - orange/yellow
  "#7c3aed", // violet-600 - purple
  "#06b6d4", // cyan-500 - cyan
  "#dc2626", // red-600 - red
  "#84cc16", // lime-500 - lime green
  "#0891b2", // cyan-600 - teal
  "#c026d3", // fuchsia-600 - magenta
  "#ea580c", // orange-600 - dark orange
  "#4f46e5", // indigo-600 - indigo
  "#65a30d", // lime-600 - olive green
  "#db2777", // pink-600 - hot pink
  "#0284c7", // sky-600 - sky blue
];

// Colors for different types of putting exercises
export const TEST_COLORS: Record<string, string> = {
  // Putting tests - each with distinct color
  "Les putts en montée": "#16a34a",        // green
  "Les Putts en descente": "#e11d48",      // rose/pink
  "Les Putts en Pente gauche droite": "#2563eb", // blue
  "Les Putts en Pente droite gauche": "#7c3aed", // violet
  "Les putts à plat": "#f59e0b",           // amber
  
  // Chipping tests - balle levée - distinct colors
  "Chipping balle levée sur terrain plat": "#06b6d4",     // cyan
  "Chipping balle levée Pente droite gauche": "#c026d3",  // fuchsia
  "Chipping balle levée Pente gauche droite": "#ea580c",  // orange
  
  // Chipping tests - balle roulée - distinct colors
  "Chipping balle roulée terrain plat": "#84cc16",         // lime
  "Chipping balle roulée pente droite gauche": "#4f46e5",  // indigo
  "Chipping balle roulée pente gauche droite": "#db2777",  // pink
  
  // Wedging tests - distinct colors
  "Wedging court": "#0891b2",                             // teal
  "Wedging mi-distance": "#dc2626",                       // red
  "Wedging court en pente gauche droite": "#65a30d",      // olive
  "Wedging court en pente droite gauche": "#0284c7",      // sky
  "Wedging mi-distance en pente gauche droite": "#7c3aed", // violet
  "Wedging mi-distance en pente droite gauche": "#f59e0b", // amber
  
  // Bunker tests
  "Bunkers court": "#ea580c",  // orange
  "Bunker long": "#c026d3",    // fuchsia
  
  // Iron and Fairway Wood tests
  "Les fers - Précision sur le parcours": "#16a34a",
  "Bois de parcours - Précision sur le parcours": "#06b6d4",
  "Attaque de green 100 m": "#e11d48",
  "Attaque de green 120 m": "#7c3aed",
  
  // Additional test patterns for putting results
  "Test de putting (Situation 1)": "#16a34a",  // green
  "Test de putting (Situation 2)": "#2563eb",  // blue
  "Test de putting (Situation 3)": "#f59e0b",  // amber
  "Test de putting (Situation 4)": "#e11d48",  // rose
  "Test de putting (Situation 5)": "#7c3aed",  // violet
  "Test de putting (Situation 6)": "#06b6d4",  // cyan
  "Test de putting (Situation 7)": "#84cc16",  // lime
  
  // Distance tendencies
  "left": "#2563eb",    // blue
  "center": "#16a34a",  // green  
  "right": "#e11d48",   // rose
  
  // Test IDs
  "chipping-plat": "#06b6d4",
  "chipping-pente-droit": "#c026d3",
  "chipping-pente-gauche": "#ea580c",
  "chipping-roulee-plat": "#84cc16",
  "chipping-roulee-pente": "#4f46e5",
  "chipping-roulee-pente-gauche": "#db2777",
  
  "wedging-cercles": "#0891b2",
  "wedging-mid": "#dc2626",
  "wedging-pente-gauche": "#65a30d",
  "wedging-pente-droite": "#0284c7",
  "wedging-mid-pente-gauche": "#7c3aed",
  "wedging-mid-pente-droite": "#f59e0b",
  
  "bunker-court": "#ea580c",
  "bunker-long": "#c026d3",
  
  "iron-precision": "#16a34a",
  "fairwayWood-precision": "#06b6d4",
  "iron-long": "#f59e0b",
  "fairwayWood-3": "#0891b2",
  "iron-green-attack": "#7c3aed",
  "iron-green-attack-100": "#e11d48",
  
  // Driver tests - each with distinct color
  "driver-precision": "#c026d3",   // fuchsia/magenta
  "driver-practice": "#dc2626",    // red
  "driver-accuracy": "#f97316",    // orange-500
  "Driver - Précision sur la mise en jeu": "#c026d3",
  "Driver - Au practice": "#dc2626",
  "Driver - Précision au driver": "#f97316",
  "Driver at practice": "#dc2626",
  "Driver precision": "#f97316",
  "Driver - Tee Shot Accuracy": "#c026d3",
  
  // Common names - distinct fallbacks
  "putting": "#16a34a",
  "chipping": "#06b6d4",
  "wedging": "#0891b2",
  "bunker": "#ea580c",
  "iron": "#2563eb",
  "fairwaywood": "#7c3aed",
  "driver": "#c026d3",
  
  "Standard": "#f59e0b",
  "Default": "#6b7280",
  
  // Translated test names (English) - various capitalizations
  "Flat putts": "#f59e0b",
  "Flat Putts": "#f59e0b",
  "Uphill putts": "#16a34a",
  "Uphill Putts": "#16a34a",
  "Downhill putts": "#e11d48",
  "Downhill Putts": "#e11d48",
  "Left-to-right slope putts": "#2563eb",
  "Left-right slope putts": "#2563eb",
  "Right-to-left slope putts": "#7c3aed",
  "Right-left slope putts": "#7c3aed",
  
  // Spanish translations
  "Putts en llano": "#f59e0b",
  "Putts en subida": "#16a34a",
  "Putts en bajada": "#e11d48",
  "Putts en pendiente izquierda derecha": "#2563eb",
  "Putts en pendiente derecha izquierda": "#7c3aed",
  
  // Test IDs from database
  "putts-plat": "#f59e0b",
  "putts-montee": "#16a34a",
  "putts-descente": "#e11d48", 
  "putts-pente": "#2563eb",
  "putts-pente-droite": "#7c3aed"
};

// Track used colors for dynamic assignment
let colorIndex = 0;
const usedColorsMap = new Map<string, string>();

// Reset color index when needed (e.g., new chart render)
export const resetColorIndex = () => {
  colorIndex = 0;
  usedColorsMap.clear();
};

// Helper function to get a color for a test type
export const getTestColor = (testName: string): string => {
  // Try direct match first
  if (TEST_COLORS[testName]) {
    return TEST_COLORS[testName];
  }
  
  // Try case-insensitive match
  const lowerTestName = testName.toLowerCase();
  for (const [key, color] of Object.entries(TEST_COLORS)) {
    if (key.toLowerCase() === lowerTestName) {
      return color;
    }
  }
  
  // Check if we already assigned a color to this test name
  if (usedColorsMap.has(testName)) {
    return usedColorsMap.get(testName)!;
  }
  
  // Check for putting situation patterns
  if (lowerTestName.includes('putting') && lowerTestName.includes('situation')) {
    const situationMatch = testName.match(/situation (\d+)/i);
    if (situationMatch) {
      const situationNum = parseInt(situationMatch[1]);
      return DISTINCT_COLORS[(situationNum - 1) % DISTINCT_COLORS.length];
    }
  }
  
  // Check for exercise type patterns
  if (lowerTestName.includes('putting') || lowerTestName.includes('putt')) return TEST_COLORS["putting"];
  if (lowerTestName.includes('chipping') || lowerTestName.includes('chip')) return TEST_COLORS["chipping"];
  if (lowerTestName.includes('wedging') || lowerTestName.includes('wedge')) return TEST_COLORS["wedging"];
  if (lowerTestName.includes('bunker')) return TEST_COLORS["bunker"];
  if (lowerTestName.includes('fer') || lowerTestName.includes('iron')) return TEST_COLORS["iron"];
  if (lowerTestName.includes('bois') || lowerTestName.includes('fairway')) return TEST_COLORS["fairwaywood"];
  if (lowerTestName.includes('driver')) return TEST_COLORS["driver"];
  
  // If it's a translation key, try to find the original French name
  if (testName.startsWith('puttingTraining.exercises.')) {
    const id = testName.replace('puttingTraining.exercises.', '');
    const frenchNameMap: Record<string, string> = {
      "putts-plat": "Les putts à plat",
      "putts-montee": "Les putts en montée",
      "putts-descente": "Les Putts en descente",
      "putts-pente": "Les Putts en Pente gauche droite",
      "putts-pente-droite": "Les Putts en Pente droite gauche"
    };
    
    const frenchName = frenchNameMap[id];
    if (frenchName && TEST_COLORS[frenchName]) {
      return TEST_COLORS[frenchName];
    }
  }
  
  // Assign a distinct color from the palette for unknown tests
  const assignedColor = DISTINCT_COLORS[colorIndex % DISTINCT_COLORS.length];
  colorIndex++;
  usedColorsMap.set(testName, assignedColor);
  
  return assignedColor;
};
